import { render, staticRenderFns } from "./ProfileFavorites.vue?vue&type=template&id=4638ca05&scoped=true&"
import script from "./ProfileFavorites.vue?vue&type=script&lang=js&"
export * from "./ProfileFavorites.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFavorites.vue?vue&type=style&index=0&id=4638ca05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638ca05",
  null
  
)

export default component.exports